import axios from "axios";
import { safeNavigate } from "../utils/navigation";
import { useAuthStore } from "../stores/authStore";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3004";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem("refreshToken");
        if (refreshToken) {
          const response = await axios.post(
            `${API_BASE_URL}/auth/refresh-token`,
            {
              refreshToken,
            }
          );

          const { accessToken } = response.data.data;
          localStorage.setItem("accessToken", accessToken);

          return api(originalRequest);
        } else {
          // No refresh token available, logout immediately
          localStorage.clear();
          // Clear the auth store as well
          useAuthStore.getState().logout();
          // Use safe navigation to avoid redirect loops
          safeNavigate("/login");
          return Promise.reject(error);
        }
      } catch (refreshError) {
        localStorage.clear();
        // Clear the auth store as well
        useAuthStore.getState().logout();
        // Use safe navigation to avoid redirect loops
        safeNavigate("/login");
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
